<template>
  <mtd-modal v-model="visible" :closable="false" width="880px" class="level-equity-dialog">
    <img v-if="isFail" class="background" src="@/assets/levelEquity/bg-fail.png" />
    <img v-else class="background" src="@/assets/levelEquity/bg.png" />

    <div class="header-top">
      <img src="@/assets/levelEquity/tag-bg.png" />
      <div class="season-name">{{ data.seasonName || '赛季名称' }}</div>
    </div>

    <div class="header-center">
      <!-- 上周期 -->
      <div class="promotion-msg" v-if="seasonType === 'prev'">
        <img class="start" src="@/assets/levelEquity/star-left.png" />
        <span>{{ data.promotionMsg }}</span>
        <img class="start" src="@/assets/levelEquity/star-right.png" />
      </div>
      <!-- 新周期 -->
      <div class="promotion-msg" v-else>
        <img v-if="isFail" class="emoji" src="@/assets/levelEquity/emoji-fail.png" />
        <img v-else class="emoji" src="@/assets/levelEquity/emoji-success.png" />
        <span>{{ data.promotionMsg }}</span>
      </div>

      <!-- 降级 / 平级 -->
      <template v-if="isFail">
        <div class="level-title">
          <span>{{ data.promotionMsgPrefix || '' }}</span>
          <span class="level-name">{{ data.levelCodeName || '' }}</span>
          <span>{{ data.promotionMsgSuffix || '级合作伙伴' }}</span>
        </div>
      </template>
      <!-- 晋升 -->
      <template v-else>
        <div class="level-title">
          <img class="green-start" src="@/assets/levelEquity/green-star-left.png" />
          <span>{{ data.promotionMsgPrefix || '' }}</span>
          <span class="level-name">{{ data.levelCodeName || '' }}</span>
          <span>{{ data.promotionMsgSuffix || '级合作伙伴' }}</span>
          <img class="green-start" src="@/assets/levelEquity/green-star-right.png" />
        </div>
      </template>
      <div class="date">{{ data.startEndDate }}</div>
    </div>

    <mtd-loading :loading="loading">
      <div class="main-content-wrapper">
        <BikeEnumSelect
          style="width: 200px;"
          v-model="supplierCode"
          labelKey="supplierName"
          valueKey="supplierCode"
          :options="partnerList"
          :clearable="false"
          @onChange="handlePartnerChange"
        />
        <div class="section-title">已解锁权益</div>
        <div class="section section-equity">
          <div class="equity-item" v-for="category in lockedEquityList" :key="category.name">
            <div class="category-name">{{ category.name }}</div>
            <div class="detail" v-if="!(category.list || []).length">-</div>
            <div class="detail" v-for="(item, index) in category.list" :key="index">
              <div class="name">{{ item.equitiesItemName }}</div>
              <div class="value">{{ item.equitiesValue }}{{ item.equitiesValueType }}</div>
            </div>
          </div>
        </div>
        <template v-if="indicatorList.length">
          <div class="section-title">
            {{ seasonType === 'prev' ? '上周期核心成就' : '已达成成就' }}
          </div>
          <div class="section section-indicator">
            <div class="indicator-wrapper" v-for="category in indicatorList" :key="category.name">
              <div class="label">{{ category.label }}</div>
              <div class="split"></div>
              <div class="indicator">
                <div class="indicator-item" v-for="(item, index) in category.items" :key="index">
                  <div class="name">{{ item.indicatorName }}</div>
                  <div class="value">{{ item.indicatorValue }}{{ item.indicatorUnitName }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </mtd-loading>
    <div slot="footer" class="u-align-center">
      <mtd-button
        v-if="seasonType === 'prev'"
        type="primary"
        :disabled="loading || errFlag"
        @click="handleNext"
      >
        我已知晓，进入新权益周期
      </mtd-button>
      <mtd-button
        v-else-if="seasonType === 'current'"
        type="primary"
        :disabled="loading || errFlag"
        @click="handleDetail"
      >
        查看详情
      </mtd-button>
    </div>
  </mtd-modal>
</template>
<script>
import api from '@/api/levelEquity'
import { EQUITY_CATEGORY_LIST } from './const'

const INDICATOR_TYPE = {
  SCALE: 1, // 规模指标
  OPERATE: 2, // 经营指标
}

const PROMOTION_TYPE = {
  PROMOTION: 1, // 晋升
  LATERAL: 2, // 平级
  DEMOTION: 3, // 降级
}

export default {
  props: {
    partnerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      PROMOTION_TYPE,
      visible: false,
      loading: false,
      seasonType: '',
      supplierCode: '',
      data: {},
      indicatorList: [],
      errFlag: false,
      lockedEquityList: EQUITY_CATEGORY_LIST,
    }
  },
  computed: {
    isFail() {
      return [PROMOTION_TYPE.LATERAL, PROMOTION_TYPE.DEMOTION].includes(this.data.promotionTypeCode)
    },
  },
  methods: {
    show(seasonId, seasonType) {
      this.visible = true
      this.seasonId = seasonId
      this.seasonType = seasonType
      this.supplierCode = (this.partnerList[0] || {}).supplierCode
      this.getSeasonInfo()
    },

    hide() {
      this.visible = false
    },

    getSeasonInfo() {
      if (this.seasonType === 'prev') {
        this.getPrevSeasonInfo()
      } else if (this.seasonType === 'current') {
        this.getCurrentSeasonInfo()
      }
    },

    /** 获取上一赛季信息 */
    getPrevSeasonInfo() {
      this.loading = true
      const params = {
        seasonId: this.seasonId,
        supplierCode: this.supplierCode,
      }
      api
        .getPrevSeasonInfo(params)
        .then(res => {
          this.data = res || {}
          this.formatData(this.data)
        })
        .catch(err => {
          this.$addOwlError({
            name: `【等级权益全局弹窗-上一赛季回顾】获取上一赛季信息失败_${err.message}`,
            msg: { params, err },
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** 获取当前赛季信息 */
    getCurrentSeasonInfo() {
      this.loading = true
      const params = {
        seasonId: this.seasonId,
        supplierCode: this.supplierCode,
        update: false,
      }
      api
        .getCurrentSeasonInfo(params)
        .then(res => {
          this.data = res || {}
          this.formatData(this.data)
        })
        .catch(err => {
          this.$addOwlError({
            name: `【等级权益全局弹窗-查看本赛季详情】获取本赛季信息失败_${err.message}`,
            msg: { params, err },
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    handlePartnerChange(val) {
      if (!val) return
      this.getSeasonInfo()
    },

    handleNext() {
      this.hide()
      setTimeout(() => {
        this.show(this.seasonId, 'current')
      })
    },

    handleDetail() {
      this.handleUpdateFlag()
      if (this.$route.path !== '/level/equity') {
        this.$router.push('/level/equity')
      }
      this.hide()
    },

    handleUpdateFlag() {
      const params = {
        seasonId: this.seasonId,
        supplierCode: this.supplierCode,
        update: true,
      }
      api
        .getCurrentSeasonInfo(params)
        .then(() => {})
        .catch(err => {
          this.$addOwlError({
            name: `【等级权益全局弹窗-查看本赛季详情】更新标记失败_${err.message}`,
            msg: { params, err },
          })
        })
    },

    formatData(data) {
      const { levelEquitiesInfosList, proportionInfoList } = data || {}
      this.lockedEquityList = this.formatLevelEquity(levelEquitiesInfosList || [])
      this.indicatorList = this.formatIndicators(proportionInfoList || [])
    },

    formatLevelEquity(data = []) {
      return EQUITY_CATEGORY_LIST.map(category => {
        const list = data.filter(item => item.equitiesCategoryCode === category.code)
        return { ...category, list }
      })
    },

    formatIndicators(data = []) {
      const scaleItems = data.filter(item => item.indicatorCategory === INDICATOR_TYPE.SCALE)
      const operateItems = data.filter(item => item.indicatorCategory === INDICATOR_TYPE.OPERATE)
      const categories = []
      if (scaleItems.length > 0) {
        categories.push({ label: '规模指标', items: scaleItems })
      }
      if (operateItems.length > 0) {
        categories.push({ label: '经营指标', items: operateItems })
      }
      return categories
    },
  },
}
</script>

<style lang="scss">
.level-equity-dialog {
  color: #000000;
  .mtd-modal {
    border-radius: 14px;
    position: relative;
    .background {
      position: absolute;
      width: 100%;
      height: 188px;
      top: 0;
      z-index: 99;
    }
  }
  .mtd-modal-content-wrapper {
    padding: 0;
  }
  .header-top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    > img {
      width: 142px;
      height: 24px;
    }
    .season-name {
      position: absolute;
      width: 142px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #000000;
      text-align: center;
    }
  }
  .header-center {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 54px;
    z-index: 100;
    .promotion-msg {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 4px;
      font-size: 20px;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 4px;
      .start {
        width: 14px;
        height: 14px;
      }
      .emoji {
        width: 32px;
        height: 32px;
        margin-right: 6px;
      }
    }
    .level-title {
      height: 56px;
      font-size: 40px;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 4px;
      .star-left {
        width: 15px;
        height: 15px;
        position: absolute;
        left: -30px;
        top: 10px;
      }
      .star-right {
        width: 20px;
        height: 20px;
        position: absolute;
        right: -30px;
        top: 0;
      }
      .green-start {
        width: 68px;
        height: 68px;
      }
      .level-name {
        color: #ff5500;
      }
    }
    .date {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
    }
  }
  .main-content-wrapper {
    padding: 0 24px;
    margin-top: 208px;
  }
  .section-title {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 8px;
    margin-top: 20px;
  }
  .section {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    &.section-equity {
      flex-direction: row;
      justify-content: space-between;
      height: max-content;
      flex-wrap: wrap;
      gap: 10px;
      .equity-item {
        max-width: 178px;
        .category-name {
          font-size: 12px;
          line-height: 20px;
          color: #94979d;
          margin-bottom: 8px;
        }
        .detail {
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          color: #000000;
          margin-bottom: 4px;
          display: flex;
          flex-wrap: wrap;
          gap: 0 10px;
          &:last-child {
            margin-bottom: 0;
          }
          .name,
          .value {
            word-break: keep-all;
          }
        }
      }
    }
    &.section-indicator {
      flex-direction: column;
      gap: 14px 0;
    }
    .indicator-wrapper {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        line-height: 20px;
        white-space: nowrap;
      }
      .split {
        width: 1px;
        height: 12px;
        background: #d8d8d8;
        margin: 0 12px;
      }
      .indicator {
        display: flex;
        flex-wrap: wrap;
        gap: 0 20px;
        .indicator-item {
          display: flex;
          align-items: center;
          .name {
            font-size: 12px;
            color: #94979d;
            margin-right: 4px;
            line-height: 22px;
          }
          .value {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
          }
        }
      }
    }
  }
  .mtd-modal-footer {
    padding-top: 0;
    .mtd-btn {
      border-color: #ffdd00;
      background: #ffdd00;
      margin-bottom: 8px;
      border-radius: 8px;
      margin-top: 8px;
      height: 40px;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
